import Vue from 'vue'
import App from './App'
import router from './config/router'
import store from './vuex/store'
import { sync } from 'vuex-router-sync'
import i18n from './config/i18n'
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import './config/loading'
import './components/shared_components/index.js'
import './components/modal/index.js'
import 'vuetify/dist/vuetify.min.css'
import ImageUploader from 'vue-image-upload-resize'
import VueMobileDetection from 'vue-mobile-detection'
import * as d3 from 'd3'
import VueCookies from 'vue-cookies'
import VueResizeObserver from 'vue-resize-observer'

import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(Vuetify)
Vue.use(ImageUploader)
Vue.use(VueMeta)
Vue.use(VueMobileDetection)
Vue.use(require('vue-prevent-parent-scroll'))
Vue.use(VueCookies)
Vue.use(VueResizeObserver)

Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        var vm = vnode.context
        var callback = binding.value
        el.clickOutsideEvent = function(event) {
            if (!(el == event.target || el.contains(event.target))) {
                return callback.call(vm, event)
            }
        }
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
})

Vue.directive('axis', {
    bind(el, binding) {
        const axis = binding.arg;
        const axisMethod = { x: "axisBottom", y: "axisLeft" }[axis];
        const methodArg = binding.value[axis];

        d3.select(el).call(d3[axisMethod](methodArg));
    }
})

sync(store, router)

async function main() {
    try {
        await store.dispatch('auth/reload')
    } finally {
        new Vue({
            el: '#app',
            router,
            store,
            i18n,
            vuetify: new Vuetify({
                icons: {
                    iconfont: 'mdiSvg'
                },
                theme: {
                    themes: {
                        light: {
                            primary: '#ff5193',
                            secondary: '#FA7268',
                            light_blue: "#9bcbeb",
                            carolina_blue: "#7BAFD4",
                            cyan_blue: "#36749d",
                            nimbus_cloud: "#DFDFe3",
                            accent: '#BFD833',
                            pms205: '#e0457a',
                        }
                    }
                }
            }),
            components: { App },
            template: '<App/>',
        })
    }
}

main()


// WEBPACK FOOTER //
// ./src/main.js